import { ApiService } from "@core/api/api-service";
import { Announcement } from "@domain/announcement/announcement";

export class AnnouncementService {
	constructor(private readonly apiService: ApiService) {}

	async getAnnouncement(id: string): Promise<Announcement> {
		const result = await this.apiService.get<Announcement>(`/me/announcements/strapi/${id}`);
		return result.data;
	}

	async markAsViewed(id: string): Promise<void> {
		await this.apiService.post<void>(`/me/announcements/strapi/${id}/view`);
	}
}
